import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withToastManager } from "react-toast-notifications";
import _ from "lodash";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamationTriangle, faExclamationCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Constants from "../../AppConstants/Constants";

const states = {
    success: {
        colors: {
            color: "rgb(0, 102, 68)",
            contentBg: "rgb(227, 252, 239)",
            iconBg: "rgb(54, 179, 126)"
        },
        icon: faCheck
    },
    error: {
        colors: {
            color: "rgb(191, 38, 0)",
            contentBg: "rgb(255, 235, 230)",
            iconBg: "rgb(255, 86, 48)"
        },
        icon: faExclamationCircle
    },
    warning: {
        colors: {
            color: "rgb(255, 139, 0)",
            contentBg: "rgb(255, 250, 230)",
            iconBg: "rgb(255, 171, 0)"
        },
        icon: faExclamationTriangle
    },
    info: {
        colors: {
            color: "rgb(80, 95, 121)",
            contentBg: "white",
            iconBg: "rgb(38, 132, 255)"
        },
        icon: faInfoCircle
    }
};

const ToastContainer = styled.div`
    box-sizing: border-box;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 8px;
    pointer-events: none;
    position: fixed;
    top: 0;
    right: 0;
    z-Index: 1000;
`;

const Toast = styled.div(({ bg, color, transitionDuration }) => ({
    backgroundColor: bg,
    boxShadow: "rgba(0, 0, 0, 0.176) 0px 3px 8px",
    color: color,
    display: "flex",
    marginBottom: 8,
    width: 360,
    transform: "translate3d(0px, 0px, 0px)",
    borderRadius: 4,
    transition: `transform ${transitionDuration}ms cubic-bezier(0.2, 0, 0, 1)`
}));

const ToastIcon = styled.div(({ bg, color }) => ({
    backgroundColor: bg,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    color: color,
    flexShrink: 0,
    paddingBottom: 8,
    paddingTop: 8,
    position: "relative",
    textAlign: "center",
    width: 30,
    overflow: "hidden"
}));

const ToastIconOverlay = styled.div`
    background-color: rgba(0, 0, 0, 0.1);
    bottom: 0;
    height: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    width: 100%;
    animation: 5000ms linear 0s 1 normal none paused animation-1kpkwyo-shrink;
`;

const ToastContent = styled.div`
    -webkit-box-flex: 1;
    flex-grow: 1;
    font-size: 14px;
    line-height: 1.4;
    min-height: 40px;
    padding: 8px 12px;
`;

const StyledLink = styled(Link)`
    color: #3094B6;
    font-weight: bold;
    cursor: pointer;
    pointer-events: auto;
`;

const CloseButton = styled.div`
    cursor: pointer;
    pointer-events: auto;
    flex-shrink: 0;
    opacity: 0.5;
    padding: 8px 12px;
    transition: opacity 150ms ease 0s;
    
    &:hover {
        opacity: 1;
    }
`;

const CloseSvg = styled.svg`
    display: inline-block;
    vertical-align: text-top;
    fill: currentcolor;
`;

const Close = styled.span`
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    border-width: 0;
    border-style: initial;
    border-color: initial;
    border-image: initial;
    overflow: hidden;
    padding: 0;
`;

class ToastNotification extends Component {
    onClose(id) {
        const { toastManager } = this.props;

        toastManager.remove(id);
    }

    render() {
        const { toastManager, children } = this.props;

        if (children.length > 0) {
            return (
                <ToastContainer>
                    {_.map(children, child => {
                        if (child.props.autoDismiss) {
                            setTimeout(() => {
                                toastManager.remove(child.key);
                            }, child.props.autoDismissTimeout);
                        }

                        return (
                            <Toast
                                key={child.key}
                                bg={states[child.props.appearance].colors.contentBg}
                                color={states[child.props.appearance].colors.color}
                                transitionDuration={child.props.transitionDuration}
                            >
                                <ToastIcon
                                    bg={states[child.props.appearance].colors.iconBg}
                                    color={states[child.props.appearance].colors.contentBg}
                                >
                                    <ToastIconOverlay/>
                                    <FontAwesomeIcon icon={child.props.icon || states[child.props.appearance].icon} />
                                </ToastIcon>
                                <ToastContent>
                                    <p>{child.props.children}</p>
                                    <StyledLink to={Constants.ENDPOINTS.CART} className="btn btn--secondary btn--sm">
                                        Proceed to cart
                                    </StyledLink>
                                </ToastContent>
                                {(!child.props.autoDismiss || child.props.showClose) &&
                                <CloseButton role="button" onClick={() => this.onClose(child.key)}>
                                    <CloseSvg aria-hidden="true" height="16" width="14" viewBox="0 0 14 16">
                                        <path fillRule="evenodd" d="M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" />
                                    </CloseSvg>
                                    <Close/>
                                </CloseButton>}
                            </Toast>
                        );
                    })}
                </ToastContainer>
            );
        }

        return null;
    }
}

export default withToastManager(ToastNotification);